export const translations = {
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      courses: 'Kurstermine',
      about: 'Über uns',
      bgCourses: 'BG-Kurse',
      contact: 'Kontakt',
      bookNow: 'Jetzt buchen',
    },
    // Hero Section
    hero: {
      title: 'Erste-Hilfe-Kurse in',
      titleHighlight: 'Düsseldorf',
      subtitle: 'Erste-Hilfe-Kurse für Führerschein & Beruf',
      rating: 'Über 340+ Top-Bewertungen auf',
      cta: 'Jetzt Platz sichern',
      ctaPrice: '40€ inkl. 19% MwSt.',
      bgCta: 'BG-Kurs anfragen',
    },
    // Quick Info Section
    quickInfo: {
      title: 'Alles Wichtige auf einen Blick',
      items: [
        'Gültig für alle Führerscheinklassen',
        'Gültig für betriebliche Ersthelfer & Studium',
        'Nur 1 Tag (7,5 Stunden)',
        'BG Zulassung (unter Med1Plus.de - 8.0559)',
        'Kursbescheinigungen sofort nach dem Kurs',
        'Gratis Passbilder',
        'Einfache Online-Anmeldung',
      ],
    },
    // Tabs
    tabs: {
      targetGroup: 'Zielgruppe',
      content: 'Inhalt',
      faq: 'FAQ',
      bgCourse: 'BG-Kurs',
    },
    // Target Group
    targetGroup: {
      title: 'Die Zielgruppe',
      description: 'Unser Erste-Hilfe-Kurs in Düsseldorf richtet sich an alle Fahrschüler der Führerscheinklassen A, A1, A2, B, BE, C, C1, CE, C1E, D, D1, DE, D1E, L, T und M – sowie an Personen, die ihre Fahrerlaubnis neu beantragen oder wiedererteilen lassen möchten.',
      compliance: 'Die Schulung erfüllt alle Anforderungen nach § 19 der Fahrerlaubnisverordnung (FeV) und ist bundesweit anerkannt. Zusätzlich entspricht der Kurs den Vorgaben der Deutschen Gesetzlichen Unfallversicherung (DGUV Vorschrift 1 und DGUV Grundsatz 304-001) – also auch gültig für betriebliche Ersthelfer.',
    },
    // Course Content
    courseContent: {
      title: 'Der Inhalt',
      intro: 'In unserem Erste-Hilfe-Kurs in Düsseldorf lernst du praxisnah und verständlich, wie du im Notfall richtig handelst.',
      subtitle: 'Die Inhalte umfassen:',
      items: [
        'Eigenschutz & Absichern der Unfallstelle',
        'Versorgung von Wunden, Blutungen & Verbrennungen',
        'Maßnahmen bei Knochenbrüchen & Gelenkverletzungen',
        'Stabile Seitenlage & Wiederbelebung (HLW)',
        'Schockvorbeugung und psychische Betreuung',
        'Wärmeerhalt bei Verletzten',
        'Helmabnahme bei bewusstlosen Motorradfahrern',
        'Erkennen & Handeln bei Schlaganfall',
        'Erste Hilfe bei Herzinfarkt',
        'Maßnahmen bei Atemnot & verlegten Atemwegen',
        'Anwendung eines AED (Automatisierter Externer Defibrillator)',
      ],
    },
    // FAQ
    faq: {
      title: 'Häufige Fragen',
      items: [
        {
          question: 'Muss ich mich online voranmelden?',
          answer: 'Nein, musst du nicht, es ist aber empfehlenswert, da der Platz dann reserviert ist. Die Plätze sind begrenzt.',
        },
        {
          question: 'Wie kann ich den Kurs bezahlen?',
          answer: 'Du kannst bequem vor Ort bar bezahlen oder deinen Platz vorher online reservieren.',
        },
        {
          question: 'Was muss ich mitbringen?',
          answer: 'Einen Ausweis oder Reisepass im Original, die Kursgebühren, Brille oder Kontaktlinsen wenn nötig und bequeme Kleidung für die praktischen Übungen.',
        },
        {
          question: 'Ist ein Sehtest und eine Passbildfotografie möglich?',
          answer: 'Passbilder ja, gratis bei jedem Besuch. Sehtest aktuell nicht, ist aber in Bearbeitung.',
        },
        {
          question: 'Kann man eine Ersatzbescheinigung bekommen?',
          answer: 'Ja, das ist kein Problem. Die Gebühr beträgt 10€.',
        },
        {
          question: 'Gibt es Pausen?',
          answer: 'Ja, alle 90 Minuten gibt es eine Pause.',
        },
      ],
    },
    // BG Courses
    bgCourses: {
      title: 'BG-Kurs für Ihre Firma beantragen',
      description: 'Sie können ganz einfach Kontakt zu uns aufnehmen, um einen BG-Kurs für betriebliche Ersthelfer zu beantragen.',
      cta: 'BG-Kurs anfragen',
      pageTitle: 'Betriebliche Ersthelfer-Kurse',
      pageDescription: 'Maßgeschneiderte Erste-Hilfe-Kurse für Ihr Unternehmen gemäß DGUV Vorschrift 1',
    },
    // Pricing
    pricing: {
      title: 'Unsere Preise',
      standard: {
        title: 'Standardpreis',
        price: '40€',
        description: 'inkl. MwSt für Fahrschüler/innen',
      },
      partner: {
        title: 'Partner-Rabatt',
        price: '35€',
        description: 'für Fahrschüler/innen unserer Partner-Fahrschulen',
      },
      group: {
        title: 'Freunde-Rabatt',
        price: '10%',
        description: 'Kommt zu dritt und spart jeder 10%',
      },
    },
    // Location
    location: {
      title: 'Veranstaltungsort',
      address: 'Ellerstraße 53',
      city: '40227 Düsseldorf',
      info: 'Direkt am Hinterausgang des Düsseldorfer Hauptbahnhofs (ca. 200 Meter)',
      nearStation: 'Nur wenige Gehminuten vom Hauptbahnhof',
    },
    // Course Times
    courseTimes: {
      title: 'Kurszeiten',
      day: 'Montag-Sonntag',
      time: '09:00 - 16:30 Uhr',
      duration: '9 Unterrichtseinheiten (ca. 7,5 Stunden)',
    },
    // Footer
    footer: {
      slogan: '"Weil Ihre Sicherheit unser Fokus ist!"',
      imprint: 'Impressum',
      privacy: 'Datenschutz',
      socialMedia: 'Social Media',
      partners: 'Unsere Partner',
      contact: 'Kontakt',
    },
    // Contact Page
    contact: {
      title: 'Kontakt',
      subtitle: 'Wir sind für Sie da',
      phone: 'Telefon / WhatsApp',
      email: 'E-Mail',
      address: 'Adresse',
      form: {
        name: 'Name',
        email: 'E-Mail',
        subject: 'Betreff',
        message: 'Nachricht',
        send: 'Nachricht senden',
      },
    },
    // About Page
    about: {
      title: 'Über uns',
      subtitle: 'Ihre Sicherheit ist unser Fokus',
      mission: 'Unsere Mission',
      missionText: 'Bei Erste-Hilfe Fokus sind wir davon überzeugt, dass jeder Mensch in der Lage sein sollte, in Notfallsituationen Leben zu retten. Unsere Kurse sind praxisnah, verständlich und werden von erfahrenen Ausbildern durchgeführt.',
      values: 'Unsere Werte',
      valuesList: [
        { title: 'Qualität', description: 'Hochwertige Ausbildung nach neuesten Standards' },
        { title: 'Praxisnähe', description: 'Realistische Übungen für echte Notfälle' },
        { title: 'Freundlichkeit', description: 'Angenehme Lernatmosphäre für alle' },
      ],
    },
    // Courses Page
    courses: {
      title: 'Kurstermine',
      subtitle: 'Wählen Sie Ihren Wunschtermin',
      loading: 'Termine werden geladen...',
    },
    // Common
    common: {
      learnMore: 'Mehr erfahren',
      bookNow: 'Jetzt buchen',
      backToHome: 'Zurück zur Startseite',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      courses: 'Course Dates',
      about: 'About Us',
      bgCourses: 'Corporate Courses',
      contact: 'Contact',
      bookNow: 'Book Now',
    },
    // Hero Section
    hero: {
      title: 'First Aid Courses in',
      titleHighlight: 'Düsseldorf',
      subtitle: 'First Aid Courses for Driving License & Work',
      rating: 'Over 340+ Top Reviews on',
      cta: 'Reserve Your Spot',
      ctaPrice: '€40 incl. 19% VAT',
      bgCta: 'Request Corporate Course',
    },
    // Quick Info Section
    quickInfo: {
      title: 'Everything at a Glance',
      items: [
        'Valid for all driving license classes',
        'Valid for workplace first aiders & students',
        'Only 1 day (7.5 hours)',
        'BG certified (under Med1Plus.de - 8.0559)',
        'Certificates immediately after the course',
        'Free passport photos',
        'Easy online registration',
      ],
    },
    // Tabs
    tabs: {
      targetGroup: 'Target Group',
      content: 'Content',
      faq: 'FAQ',
      bgCourse: 'Corporate',
    },
    // Target Group
    targetGroup: {
      title: 'Target Group',
      description: 'Our first aid course in Düsseldorf is designed for all driving students of license classes A, A1, A2, B, BE, C, C1, CE, C1E, D, D1, DE, D1E, L, T and M – as well as for people who want to apply for or renew their driving license.',
      compliance: 'The training meets all requirements according to § 19 of the German Driving License Regulation (FeV) and is recognized nationwide. Additionally, the course complies with the regulations of the German Social Accident Insurance (DGUV Regulation 1 and DGUV Principle 304-001) – therefore also valid for workplace first aiders.',
    },
    // Course Content
    courseContent: {
      title: 'Course Content',
      intro: 'In our first aid course in Düsseldorf, you will learn in a practical and understandable way how to act correctly in an emergency.',
      subtitle: 'The contents include:',
      items: [
        'Self-protection & securing the accident scene',
        'Treatment of wounds, bleeding & burns',
        'Measures for bone fractures & joint injuries',
        'Recovery position & CPR (cardiopulmonary resuscitation)',
        'Shock prevention and psychological support',
        'Heat preservation for injured persons',
        'Helmet removal for unconscious motorcyclists',
        'Recognizing & acting on stroke',
        'First aid for heart attack',
        'Measures for breathing difficulties & blocked airways',
        'Use of an AED (Automated External Defibrillator)',
      ],
    },
    // FAQ
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          question: 'Do I need to register online in advance?',
          answer: 'No, you don\'t have to, but it is recommended as your spot will be reserved. Spaces are limited.',
        },
        {
          question: 'How can I pay for the course?',
          answer: 'You can pay in cash on site or reserve your spot online in advance.',
        },
        {
          question: 'What do I need to bring?',
          answer: 'An ID card or passport in original, the course fee, glasses or contact lenses if necessary, and comfortable clothing for practical exercises.',
        },
        {
          question: 'Is an eye test and passport photo possible?',
          answer: 'Passport photos yes, free with every visit. Eye test currently not available, but in progress.',
        },
        {
          question: 'Can I get a replacement certificate?',
          answer: 'Yes, that is no problem. The fee is €10.',
        },
        {
          question: 'Are there breaks?',
          answer: 'Yes, there is a break every 90 minutes.',
        },
      ],
    },
    // BG Courses
    bgCourses: {
      title: 'Request Corporate Course for Your Company',
      description: 'You can easily contact us to request a corporate first aid course for workplace first aiders.',
      cta: 'Request Corporate Course',
      pageTitle: 'Corporate First Aid Courses',
      pageDescription: 'Customized first aid courses for your company according to DGUV Regulation 1',
    },
    // Pricing
    pricing: {
      title: 'Our Prices',
      standard: {
        title: 'Standard Price',
        price: '€40',
        description: 'incl. VAT for driving students',
      },
      partner: {
        title: 'Partner Discount',
        price: '€35',
        description: 'for students of our partner driving schools',
      },
      group: {
        title: 'Friends Discount',
        price: '10%',
        description: 'Come with three friends and each save 10%',
      },
    },
    // Location
    location: {
      title: 'Venue',
      address: 'Ellerstraße 53',
      city: '40227 Düsseldorf',
      info: 'Right at the back exit of Düsseldorf Main Station (approx. 200 meters)',
      nearStation: 'Just a few minutes walk from the main station',
    },
    // Course Times
    courseTimes: {
      title: 'Course Times',
      day: 'Monday-Sunday',
      time: '09:00 AM - 4:30 PM',
      duration: '9 teaching units (approx. 7.5 hours)',
    },
    // Footer
    footer: {
      slogan: '"Because your safety is our focus!"',
      imprint: 'Imprint',
      privacy: 'Privacy Policy',
      socialMedia: 'Social Media',
      partners: 'Our Partners',
      contact: 'Contact',
    },
    // Contact Page
    contact: {
      title: 'Contact',
      subtitle: 'We are here for you',
      phone: 'Phone / WhatsApp',
      email: 'Email',
      address: 'Address',
      form: {
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message',
        send: 'Send Message',
      },
    },
    // About Page
    about: {
      title: 'About Us',
      subtitle: 'Your safety is our focus',
      mission: 'Our Mission',
      missionText: 'At Erste-Hilfe Fokus, we believe that everyone should be able to save lives in emergency situations. Our courses are practical, understandable, and conducted by experienced instructors.',
      values: 'Our Values',
      valuesList: [
        { title: 'Quality', description: 'High-quality training according to the latest standards' },
        { title: 'Practical Relevance', description: 'Realistic exercises for real emergencies' },
        { title: 'Friendliness', description: 'Pleasant learning atmosphere for everyone' },
      ],
    },
    // Courses Page
    courses: {
      title: 'Course Dates',
      subtitle: 'Choose your preferred date',
      loading: 'Loading dates...',
    },
    // Common
    common: {
      learnMore: 'Learn more',
      bookNow: 'Book now',
      backToHome: 'Back to home',
    },
  },
};
